module.exports = __webpack_public_path__ + "static/media/logo.d2db1656.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 386
// module chunks = 0